module.exports = __webpack_public_path__ + "img/22_40.91d99ed2.png";